var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading_line",style:(_vm.style)},[_c('img',{attrs:{"src":require("./gif_01.gif")}}),_vm._t("default",function(){return [_vm._v("数据加载中...")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }